import { Menu, X } from 'lucide-react';
import { useEffect, useState, type ReactNode } from 'react';
import { contactDetails, positioning, siteLinks } from '../content/siteContent';
import { NewsletterSignup } from './components/NewsletterSignup';
import { getPublicNavigation } from '../lib/api';
import type { CustomPage } from '../lib/types';

const navigation = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Speaking', href: '/speaking' },
  { label: 'Engagements', href: '/engagements' },
  { label: 'Books & Media', href: '/books-media' },
  { label: 'Contact', href: '/contact' }
] as const;

export function PublicLayout({ children }: { children: ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [customNavigation, setCustomNavigation] = useState<CustomPage[]>([]);
  const currentPath = window.location.pathname;
  useEffect(() => { getPublicNavigation().then(setCustomNavigation).catch(() => undefined); }, []);

  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="site-header">
        <a className="wordmark" href="/" aria-label="Christina J Barea home">
          <span>{positioning.name}</span>
          <small>Speaker · Author · Qigong</small>
        </a>
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="site-navigation"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
        <nav id="site-navigation" className="site-nav" data-open={menuOpen} aria-label="Main navigation">
          {navigation.map((item) => (
            <a
              key={item.href}
              href={item.href}
              aria-current={currentPath === item.href ? 'page' : undefined}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
          {customNavigation.map((page) => <a key={page.id} href={`/pages/${page.slug}`} aria-current={currentPath === `/pages/${page.slug}` ? 'page' : undefined} onClick={() => setMenuOpen(false)}>{page.title}</a>)}
        </nav>
        <a className="button header-cta" href="/contact">Book Christina</a>
      </header>
      <main id="main-content">{children}</main>
      <NewsletterSignup />
      <footer className="site-footer">
        <div className="site-footer__identity">
          <strong>{positioning.name}</strong>
          <span>Keynotes · Workshops · Corporate Programs</span>
        </div>
        <div className="site-footer__links">
          <a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a>
          <a href={siteLinks.fivePhases}>Visit Five Phases Health</a>
          <a href={siteLinks.newsletter}>Read the newsletter</a>
        </div>
        <p className="site-footer__legal">© {new Date().getFullYear()} Christina J Barea</p>
      </footer>
    </div>
  );
}
